<template>
    <section class="tags-wrapper pt-80px pb-80px position-relative">
        <div class="container">
            <div class="row">

                <!-- Sidebar -->
                <div class="col-md-2">
                    <questions-sidebar />
                </div>

                <!-- All Tags -->
                <div class="col-md-7">
                    <div class="tags-tab-wrapper">
                        <tags-header :title="dlabData.tagsTab.title" :description="dlabData.tagsTab.description" />

                        <div class="tag-lists d-grid">
                            <tag-list :tags="dlabData.tagsTab.tags" />
                        </div>

                        <question-pagination />

                    </div>
                </div>

                <!-- Right Sidebar -->
                <div class="col-md-3">
                    <questions-sidebar-2 />
                </div>
            </div>
        </div>
    </section>
</template>


<script>
import dlabData from '@/store/store.js'
import QuestionsSidebar from '../sidebars/QuestionsSidebar.vue';
import QuestionsSidebar2 from '../sidebars/QuestionsSidebar2.vue';
import QuestionPagination from '../dynamic/QuestionPagination.vue';
import TagsHeader from '../pieces/TagsHeader.vue';
import TagList from '../cards/TagList.vue';

export default {
    name: 'Questions',
    components: {
        QuestionsSidebar,
        QuestionsSidebar2,
        QuestionPagination,
        TagsHeader,
        TagList,
    },
    data() {
        return {
            dlabData,
        }
    },
    methods: {

    },
    mounted() {
        
    }
}
</script>